var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import query from 'syf-component-library/const/mediaQueries';
import { spacing } from 'syf-component-library/defaultTheme';
import ErrorScreen from '../../../../ui/patterns/Accordion/subcomponents/DisputesFailureError';
var Content = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  margin: 0 72px;\n  text-align: center;\n  @media ", " {\n    margin: 0 ", "px;\n  }\n"], ["\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  margin: 0 72px;\n  text-align: center;\n  @media ", " {\n    margin: 0 ", "px;\n  }\n"])), query.lessThanMedium, spacing.xlarge);
var APIError = function () {
    // TODO: possibly insert trigger analytics event call here in use effect
    return (_jsx(Content, { children: _jsx(ErrorScreen, {}) }));
};
export default APIError;
var templateObject_1;
//# sourceMappingURL=index.js.map